import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/routing/rootRoute.ts';
import SettingApprovalPage from '@/features/public/settingApproval/pages/SettingApprovalPage.tsx';

const searchSchema = z.object({
  token: z.string().optional(),
});

export const settingApprovalRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/setting-approval',
  component: SettingApprovalPage,
  validateSearch: searchSchema,
});
